"use strict";
var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function(callback) {
  }
};
module.exports = ReactServerBatchingStrategy;
